import React, { useEffect } from 'react';
import './HomePage.css'; // 引入新的CSS文件
import './guanggao.css'; // 引入广告的CSS文件
import QRCodeImg from './images/gg01.png'; // 引入图像

const IFRAME_SRC = "https://vc.check-look.com/iframeWrapper?va=UE_you7";
const IMAGE_ALT = "Description of the image";

const handleIframeError = (e) => {
  console.error('Iframe failed to load:', e);
};

const handleImageError = (e) => {
  console.error('Image failed to load:', e);
};

const ServicePage = () => {
  useEffect(() => {
    // 组件挂载时添加类名以禁止滚动
    document.body.classList.add('no-scroll');
    return () => {
      // 组件卸载时移除类名以恢复滚动
      document.body.classList.remove('no-scroll');
    };
  }, []);

  return (
    <main className="snap-container">
      <section className="snap-section">
        <div className="flex flex-col h-screen">
          {/* 上半部分，占屏幕高度的40%，嵌入网页链接 */}
          <div className="h-2/5">
            <iframe
              src={IFRAME_SRC}
              title="Embedded Web Page"
              width="100%"
              height="100%"
              frameBorder="0"
              onError={handleIframeError}
            ></iframe>
          </div>
          {/* 下半部分，占屏幕高度的60%，显示图片 */}
          <div className="h-3/5">
            <img
              src={QRCodeImg}
              alt={IMAGE_ALT}
              className="w-full h-full object-cover"
              onError={handleImageError}
            />
          </div>
        </div>
      </section>
    </main>
  );
}

export default ServicePage;
